import {
    ProductLabelTemplateDTO,
    ProductLabelTemplateField,
    SuccessfulResult,
    UpdateProductLabelTemplateParams,
} from "@/dto/template/ProductLabelTemplateDTO";
import httpClient from "@/services/http/mainServerClient";

export function getTemplates() {
    return httpClient.get<ProductLabelTemplateDTO[]>("/product_label_template/list");
}

export async function getTemplate(id: number) {
    const templates = await getTemplates();
    const template = templates.find((item) => item.id === id);

    if (!template) {
        throw new Error("模板不存在");
    }

    return template;
}

export function createTemplate(params: UpdateProductLabelTemplateParams) {
    return httpClient.post<ProductLabelTemplateDTO>("/product_label_template/create", params);
}

export function updateTemplate(id: number, params: UpdateProductLabelTemplateParams) {
    return httpClient.post<ProductLabelTemplateDTO>(`/product_label_template/update/${id}`, params);
}

export function deleteTemplate(id: number) {
    return httpClient.post<SuccessfulResult>(`/product_label_template/delete/${id}`);
}

export function copyTemplate(templateId: number) {
    return httpClient.post<ProductLabelTemplateDTO>(`/product_label_template/${templateId}:copy`);
}

export function toProductLabelTemplateField(field: ProductLabelTemplateField): ProductLabelTemplateField {
    const requestField: ProductLabelTemplateField = {
        key: field.key,
        width: field.width,
        height: field.height,
        left: field.left,
        top: field.top,
        fontSize: field.fontSize,
        fontWeight: field.fontWeight,
        fontFamily: field.fontFamily,
        value: field.value || "",
    };

    if (typeof field.id === "number") {
        requestField.id = field.id;
    }

    return requestField;
}
